/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SolicitudVacacionesService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Obtiene solo el resumen de bonos para validación
   * Usa fechas fijas: 1990-01-01 a 9999-12-01
   */
  async validarBonosDisponibles(idPersona: number): Promise<any> {
    const body = {
      fecha_inicio: '1990-01-01',
      fecha_fin: '9999-12-01',
      id_persona: String(idPersona),
      solo_resumen: true,
    };
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'sap/solicitud_vacaciones', body),
    );
  }

  /**
   * Obtiene el detalle completo de períodos de vacaciones
   * Usa fecha dinámica del mes actual
   */
  async getSolicitudVacaciones(idPersona: number): Promise<any> {
    const hoy = new Date();
    const fechaInicio = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-01`;
    const body = {
      fecha_inicio: fechaInicio,
      fecha_fin: '9999-12-01',
      id_persona: String(idPersona),
      solo_resumen: false,
    };
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'sap/solicitud_vacaciones', body),
    );
  }

  async postPagoBonoVacaciones(fechaInicio: string, idPersona: string): Promise<any> {
    const body = {
      fecha_inicio: fechaInicio,
      fecha_fin: '9999-12-01',
      id_persona: idPersona,
    };
    console.log('=== 📤 Valores enviados a sap/pagobonovacaciones ===');
    console.log('Body completo:', body);
    console.log('fecha_inicio:', fechaInicio, '(tipo:', typeof fechaInicio, ', length:', fechaInicio?.length, ')');
    console.log('id_persona:', idPersona, '(tipo:', typeof idPersona, ', length:', idPersona?.length, ')');
    console.log('URL completa:', enviroment.url + 'sap/pagobonovacaciones');
    console.log('====================================================');
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'sap/pagobonovacaciones', body),
    );
  }
}
